import { render, staticRenderFns } from "./CourierMap.vue?vue&type=template&id=af7b42e4&scoped=true&"
import script from "./CourierMap.vue?vue&type=script&lang=js&"
export * from "./CourierMap.vue?vue&type=script&lang=js&"
import style0 from "./CourierMap.vue?vue&type=style&index=0&id=af7b42e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7b42e4",
  null
  
)

export default component.exports